import React, {useCallback} from "react";
import {Controller, useFormContext} from "react-hook-form";
import {SimpleDropdown} from "../../../../common";
import {ClientReportSubmitInput} from "../../domain";
import {relatedFieldsToBeSetNullOnNoServiceRecommended, ServiceRecommended, ServiceRecommendedOptions} from "./domain";
import {shouldShowServiceRecommendedInput} from "./view-domains";


type Props = {
    reportType: string;
    isForStaffingPlan: boolean;
    disabled: boolean;
};

export function ServiceRecommendedInput({reportType, isForStaffingPlan, disabled}: Props) {
    const {
        setValue,
        clearErrors,
        control,
        formState: {
            errors
        },
    } = useFormContext<ClientReportSubmitInput>();

    const resetRelatedFieldsOnNo = useCallback(() => {
        setValue('serviceType', []);
        relatedFieldsToBeSetNullOnNoServiceRecommended.forEach((field) => {
            setValue(field, null);
        });
    }, [setValue])

    if (!shouldShowServiceRecommendedInput(reportType, isForStaffingPlan)) {
        return null;
    }

    return (
        <div className="text-black-200 pb-2 text-base">
            <div className="flex">
                <div className="flex items-center">
                    Service Recommended
                </div>
                <div className="ml-4 items-center">
                    <Controller
                        name="serviceRecommended"
                        control={control}
                        rules={{
                            required: true
                        }}
                        render={({field: {value}}) =>
                            <SimpleDropdown
                                options={ServiceRecommendedOptions}
                                selected={value}
                                disabled={disabled}
                                hasErrorBorder={errors.serviceRecommended !== undefined}
                                setSelected={(selected) => {
                                    setValue("serviceRecommended", selected);
                                    if (ServiceRecommendedOptions.get(selected) === ServiceRecommended.No) {
                                        resetRelatedFieldsOnNo();
                                    }
                                    clearErrors("serviceRecommended");
                                }}
                                textColor={"black-200"}
                            />
                        }/>
                </div>
            </div>

            {
                errors.serviceRecommended &&
                <div className="text-red-700">
                    Please select “Service Recommended” before submitting
                </div>
            }
        </div>
    )
}
